import {
  addAddonsAndTopUpsOnOrder,
  fetchCartData,
  startCountdown,
  stopCountdown,
} from 'store/cartSlice';
import { CartItem } from 'types/CartItem';
import { Ticket } from 'types/TicketsState';
import { splitCartItemsToIndividualTickets } from 'utils/tickets';
import { addAddonsToSelectedItems, addCalendarTicketsToCart } from './index'; // Import your actions

export const createChatBaseCart = (
  chatbaseSelectedItems: any[],
  attendanceDate: string,
): any => {
  return async (dispatch, getState) => {
    // add tickets to cart
    const chatbaseTickets = chatbaseSelectedItems.filter(
      item => item.type === 'ticket',
    );

    chatbaseTickets.forEach(({ id, quantity }) => {
      dispatch(
        addCalendarTicketsToCart({
          ticketId: id,
          quantity,
          date: attendanceDate,
        }),
      );
    });

    // reserve tickets
    await dispatch(
      fetchCartData({
        event: getState().ticketSale.selectedEvent,
        selectedTickets: getState().ticketSale.selectedItems,
        selectedBundles: [],
      }),
    );

    // add addons to cart
    const displayedTickets = splitCartItemsToIndividualTickets(
      getState().ticketSale.selectedItems,
      getState().ticketSale.selectedEvent,
    );

    const chatbaseAddons = chatbaseSelectedItems.filter(
      item => item.type === 'addon',
    );

    chatbaseAddons.forEach(({ id, quantity }) => {
      // below we search for the ticket category that has the current addon
      // because when you insert an addon in the cart, you need to provide the "ticketId" property
      const ticket = getState().ticketSale.selectedEvent.tickets.find(
        ticket => ticket.ticketaddons.findIndex(addon => addon.id === id) >= 0,
      ) as Ticket;

      // below we find the ticket that is currently in the cart
      const selectedTicket = getState().ticketSale.selectedItems.find(
        item => item.ticketId === ticket.id,
      ) as CartItem;

      const addonsPerTickets = quantity / selectedTicket.quantity;
      // if the addon quantity is a multiple of the ticket quantity, distribute addon equally to all tickets
      if (Number.isInteger(addonsPerTickets)) {
        // each addon inserted in selectedItems needs to have a ticketIndex,
        // so we need to find the first index of the ticket in the displayedTickets array
        const ticketFirstIndex = displayedTickets.findIndex(
          displayedTicket => displayedTicket.ticketId === ticket.id,
        );
        let ticketIndex = ticketFirstIndex;

        for (let i = 0; i < quantity; i++) {
          dispatch(
            addAddonsToSelectedItems({
              event: getState().ticketSale.selectedEvent,
              addon: {
                ticketId: ticket.id,
                addonId: id,
                quantity: addonsPerTickets,
                ticketIndex,
                ticketDate: attendanceDate,
                absorbFees: ticket.ticketprice[0].absorb_fees,
              },
            }),
          );
          ticketIndex++;
        }
      } else {
        // else set all addon quantity to the first ticket
        dispatch(
          addAddonsToSelectedItems({
            event: getState().ticketSale.selectedEvent,
            addon: {
              ticketId: ticket.id,
              addonId: id,
              quantity,
              ticketIndex: 0,
              ticketDate: attendanceDate,
              absorbFees: ticket.ticketprice[0].absorb_fees,
            },
          }),
        );
      }
    });

    // reserve addons
    const selectedAddons = getState().ticketSale.selectedItems.filter(
      item => item.addonId !== null && item.included === false,
    );

    await dispatch(
      addAddonsAndTopUpsOnOrder({
        cartUUID: getState().cart.uuid,
        eventId: getState().ticketSale.selectedEvent.id,
        addons: selectedAddons,
        topUps: [],
        tickets: displayedTickets,
        ticketsData: getState().ticketSale.selectedEvent.tickets,
      }),
    );

    // start countdown
    dispatch(stopCountdown());
    dispatch(
      startCountdown({
        vendorId: getState().ticketSale.selectedEvent.id_seller,
        eventId: getState().ticketSale.selectedEvent.id,
      }),
    );
  };
};
